/**
 * Helpers del custom field tipo 37 (autocomplete + redirect).
 * Mantener puro: el componente solo orquesta form / UI.
 */

export function hasType37AutocompleteValue(value: unknown): boolean {
  return value != null && String(value).trim() !== '';
}

/** Misma forma de evento que emite el input al borrar a mano. */
export function type37ClearChangeEvent(): { target: { value: '' } } {
  return { target: { value: '' } };
}

/**
 * Bloqueo efectivo del tipo 37: copy-lock de fila o flags del backend
 * (`readonly` / `disabled`, p. ej. vía fielddependencies).
 */
export function isType37FieldLocked(opts: {
  copyLocked?: boolean;
  readonly?: unknown;
  disabled?: unknown;
}): boolean {
  return !!(opts.copyLocked || opts.readonly || opts.disabled);
}

export function shouldShowType37Clear(value: unknown, locked: boolean): boolean {
  return hasType37AutocompleteValue(value) && !locked;
}
